import { PlayIcon } from "@heroicons/react/24/solid";
import { GameConfiguration } from "shared/games/types/GameConfiguration";
import { GameAnswerMixPuzzle } from "shared/games/types/GameAnswers";
import { GameQuestionMixPuzzle } from "shared/games/types/GameQuestions";
import Button from "ui/atoms/Button/Button";
import Switch, { SwitchItem } from "ui/atoms/Switch/Switch";
import { useAudioChangeController } from "../hooks/useAudioChangeController";
import { State } from "../state/reducer";
import useMixPuzzleState from "../state/useMixPuzzleState";
import MixPuzzleTemplate from "../templates/MixPuzzleTemplate";
import * as GameLayout from "ui/templates/Game/LayoutComponents";

const MixPuzzleFailedScreen: GameConfiguration<
  GameQuestionMixPuzzle,
  GameAnswerMixPuzzle
>["FailureScreen"] = ({
  question,
  answer,
  onLoaded,
  onNext,
  mobileToolbarStyle,
}) => {
  const [state, dispatch] = useMixPuzzleState({
    type: "failed-screen",
    mixPuzzle: question.mixPuzzle,
    grade: answer.grade,
    difficulty: question.difficulty,
  });
  const { playing, setPlaying } = useAudioChangeController({
    state,
    onLoaded,
    initialPlayState: false,
  });

  return (
    <>
      <GameLayout.Toolbar mobileStyle={mobileToolbarStyle}>
        <div
          className={
            "hide-scroll-bars flex w-full items-center justify-between overflow-auto"
          }
        >
          <div className={"mr-2 flex items-center"}>
            <div className={"mr-2"}>
              <Button
                size={"large"}
                theme={"default"}
                active={playing}
                onClick={() => setPlaying((x) => !x)}
                icon={(props) => {
                  return <PlayIcon {...props} />;
                }}
              />
            </div>
          </div>

          <Button theme={"green"} onClick={onNext} size={"large"}>
            Next
          </Button>
        </div>
      </GameLayout.Toolbar>

      <MixPuzzleTemplate
        state={state}
        dispatch={dispatch}
        mobileToolbarStyle={mobileToolbarStyle}
      />
    </>
  );
};

export default MixPuzzleFailedScreen;
